// store/page/material/materialThunk.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  GET_FRONT_PART,
  ADD_FRONT_PART,
  FETCH_SHOWER_TESTING,
  ADD_SHOWER_TESTING,
  DAILY_SHELL_REPORT,
  DAILY_SHELL_REPORT_LIST,
  MONTHLY_SHELL_REPORT,
  ADD_LAV_SIDE_WALL,
  GET_LAV_SIDE_WALL,
  ADD_SHELL_VITAL_POINTS,
  FETCH_SHELL_VITAL_POINT_DAILY,
  MONTHLY_INSPECTION_REPORT_LIST,
} from '../../../api/apiConstant';
import api from '../../../api/apiServises';

export const addFrontPartInspection = createAsyncThunk(
  'frontPart/addFrontPartInspection',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_FRONT_PART, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const addLavSideWallInspection = createAsyncThunk(
  'frontPart/addLavSideWallInspection',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_LAV_SIDE_WALL, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Fetch all front part inspections with pagination
export const fetchFrontPartInspections = createAsyncThunk(
  'frontPart/fetchFrontPartInspections',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_FRONT_PART, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const addShowerTestingInspection = createAsyncThunk(
  'showerTesting/addShowerTestingInspection',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_SHOWER_TESTING, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          'Failed to save shower testing inspection',
      );
    }
  },
);

export const fetchShowerTestingInspections = createAsyncThunk(
  'showerTesting/fetchShowerTestingInspections',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_SHOWER_TESTING, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getDailyShellReport = createAsyncThunk(
  'report/getDailyShellReport',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(DAILY_SHELL_REPORT, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          'Failed to save shower testing inspection',
      );
    }
  },
);
export const getDailyShellReportList = createAsyncThunk(
  'report/getDailyShellReportList',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(DAILY_SHELL_REPORT_LIST, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed fetch report list',
      );
    }
  },
);

export const getMonthlyShellReportList = createAsyncThunk(
  'report/getMonthlyShellReportList',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(MONTHLY_SHELL_REPORT, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed fetch report list',
      );
    }
  },
);
// Fetch all front part inspections with pagination
export const fetchLavSideWallInspections = createAsyncThunk(
  'frontPart/fetchLavSideWallInspections',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_LAV_SIDE_WALL, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const addShellVitalPoints = createAsyncThunk(
  'frontPart/addShellVitalPoints',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_SHELL_VITAL_POINTS, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getDailyShellVitalreport = createAsyncThunk(
  'wheel/getDailyShellVitalreport',
  async (params) => {
    const response = await api.get(FETCH_SHELL_VITAL_POINT_DAILY, { params });
    return response.data;
  },
);

export const getMonthlyInspectionReportList = createAsyncThunk(
  'report/getMonthlyInspectionReportList',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(MONTHLY_INSPECTION_REPORT_LIST, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to fetch inspection report list',
      );
    }
  },
);


export const getMonthlyInspectionReportExport = createAsyncThunk(
  'report/getMonthlyInspectionReportExport',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(MONTHLY_INSPECTION_REPORT_LIST, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to fetch inspection report list',
      );
    }
  },
);